import { put, select } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import { actions, selectors } from "rdx";
import { pickBy, identity, clone, cloneDeep } from "lodash";

import { keysToCamelCase, keysToSnakeCase } from "lib/helpers";
import messages from "../messages";

function* getMentors(action) {
  const { requestFreshData = true } = action.payload || {};

  const {
    spoken_languages,
    appt_location,
    team_search,
    mentor_search,
    service_area,
    powur_pair_for_project,
    project_id,
    sort,
    filters,
    reverse,
  } = keysToSnakeCase(action.payload) || {};

  const existingList = yield select(selectors.getMentorsList);
  const nextPage = existingList?.paging?.page_number + 1 || 1;
  const params = {
    limit: 20,
    spoken_languages,
    appt_location,
    team_search,
    q: mentor_search,
    service_area,
    powur_pair_for_project,
    project_id,
    sort,
    filters,
    reverse,
    ...(!requestFreshData && { p: nextPage }),
  };

  if (!params.sort && !params.filters) params.sort = "mentor_rating";
  const { success, data, error } = yield* makeRequest.get("/users/mentors", pickBy(params, identity));

  // determines whether to set as full mentor list or powur pair list
  const setMentorListAction = action?.payload?.powurPairForProject ? actions.setPowurPairList : actions.setMentorsList;

  if (success && data) {
    const out = clone(data.body);
    if (out.users) {
      out.users = data.body.users.map((user) => {
        const newUser = clone(user);
        newUser.metrics = {};
        user.metrics.forEach((metric) => {
          const key = Object.keys(metric)[0];
          const value = Object.values(metric)[0];
          newUser.metrics[key] = value;
        });
        return keysToCamelCase(newUser);
      });

      const { paging, users: newMentorList } = out;
      const concatList = cloneDeep(existingList.users).concat(newMentorList);
      const mentorList = requestFreshData ? newMentorList : concatList;
      yield put(setMentorListAction({ paging, users: mentorList }));
    }
    if (out.filters) {
      if (out.filters.service_areas) {
        out.filters.service_areas.sort((a, b) => Object.values(a)[0].localeCompare(Object.values(b)[0]));
      }
      yield put(actions.setMentorFilters({ filters: keysToCamelCase(out.filters) }));
    }
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_MENTOR_LIST,
    });
  }
  return null;
}

export default getMentors;
